// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/ProfilePage/RoleSelectModal.module.scss */
.RoleSelectModal_overlay__AFhs7 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.RoleSelectModal_modal__Mo6HX {
  background: #fff;
  border-radius: 18px;
  padding: 32px 24px 20px;
  min-width: 310px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.17);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.RoleSelectModal_title__6XeC6 {
  margin: 0 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: #222;
  text-align: center;
}

.RoleSelectModal_buttonGroup__GFMWa {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.RoleSelectModal_roleBtn__ul0ea {
  width: 100%;
  background: #e50040;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 13px 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.RoleSelectModal_cancelBtn__WlTbh {
  width: 100%;
  background: transparent;
  color: #666;
  font-size: 15px;
  font-weight: 500;
  padding: 11px 0 4px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.18s;
}
.RoleSelectModal_cancelBtn__WlTbh:hover {
  background: #f6f6f7;
}

.RoleSelectModal_roleBtn__ul0ea:hover {
  background: #bb0033;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ProfilePage/RoleSelectModal.module.scss"],"names":[],"mappings":"AAAA,sDAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,mBAAA;AAAF","sourcesContent":["/* src/pages/ProfilePage/RoleSelectModal.module.scss */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 18px;\n  padding: 32px 24px 20px;\n  min-width: 310px;\n  max-width: 95vw;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.17);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n.title {\n  margin: 0 0 10px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #222;\n  text-align: center;\n}\n\n.buttonGroup {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.roleBtn {\n  width: 100%;\n  background: #e50040;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 13px 0;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cancelBtn {\n  width: 100%;\n  background: transparent;\n  color: #666;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 11px 0 4px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.18s;\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.roleBtn:hover {\n  background: #bb0033;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RoleSelectModal_overlay__AFhs7`,
	"modal": `RoleSelectModal_modal__Mo6HX`,
	"title": `RoleSelectModal_title__6XeC6`,
	"buttonGroup": `RoleSelectModal_buttonGroup__GFMWa`,
	"roleBtn": `RoleSelectModal_roleBtn__ul0ea`,
	"cancelBtn": `RoleSelectModal_cancelBtn__WlTbh`
};
export default ___CSS_LOADER_EXPORT___;
